import type { AfterContentInit } from '@angular/core';
import {
  Output,
  Input,
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  QueryList,
} from '@angular/core';
import { slideY } from '@studiobuki/web-core';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged, skip } from 'rxjs/operators';
import { AccordeonItemComponent } from './components/accordeon-item/accordeon-item.component';

type TValue = AccordeonItemComponent['value'] | undefined;

@Component({
  selector: 'lib-accordeon',
  templateUrl: './accordeon.component.html',
  styleUrls: ['./accordeon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [slideY()],
})
export class AccordeonComponent implements AfterContentInit {
  @ContentChildren(AccordeonItemComponent)
  items!: QueryList<AccordeonItemComponent>;

  @Input() set value(value: TValue) {
    this._value$.next(value);
  }

  get value() {
    return this._value$.value;
  }

  private _value$ = new BehaviorSubject<TValue>(undefined);

  public value$ = this._value$.pipe(distinctUntilChanged());

  @Output() valueChange = this.value$.pipe(skip(1));

  private _items$ = new BehaviorSubject<AccordeonItemComponent[]>([]);

  public items$ = this._items$.asObservable();

  // constructor() {}

  ngAfterContentInit(): void {
    this.items.changes.subscribe((items: QueryList<AccordeonItemComponent>) => {
      // console.log({ items });
      this._collectItems(items);
    });

    this.items.notifyOnChanges();
  }

  public onItemClick(value: TValue) {
    this._value$.next(value);
  }

  private _collectItems(items: QueryList<AccordeonItemComponent>) {
    this._items$.next(items.map((item) => item));
  }
}
